import 'angular:locale/data:pt';
import 'angular:locale/data:ja';
import 'angular:locale/data:it';
import 'angular:locale/data:ar';
import 'angular:locale/data:fr';
import 'angular:locale/data:es';
import 'angular:locale/data:he';
import 'angular:locale/data:en';
import 'zone.js';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
